// fix-search-fullwidth-solution.js
// 検索モーダルを画面幅100%で表示（完全版）

(function() {
  'use strict';
  
  console.log('=== Search Fullwidth Solution Loaded ===');
  
  let searchIsOpen = false;
  
  function init() {
    const searchDetails = document.querySelector('.header__search details');
    const searchSummary = searchDetails ? searchDetails.querySelector('summary') : null;
    const stickyHeader = document.querySelector('sticky-header');
    const searchModal = document.querySelector('.search-modal');
    const searchContent = document.querySelector('.search-modal__content');
    
    if (!searchDetails || !searchSummary) {
      setTimeout(init, 100);
      return;
    }
    
    console.log('Search fullwidth solution initialized');
    
    // === 1. ヘッダーが隠れるのを防止 ===
    
    searchDetails.addEventListener('toggle', function() {
      searchIsOpen = searchDetails.hasAttribute('open');
      console.log('Search state:', searchIsOpen ? 'OPEN' : 'CLOSED');
      
      if (searchIsOpen) {
        const header = document.querySelector('.section-header');
        if (header) {
          header.classList.remove('shopify-section-header-hidden');
          header.classList.add('shopify-section-header-sticky');
        }
        applyFullwidthFix();
      }
    });
    
    if (stickyHeader && stickyHeader.hide) {
      const originalHide = stickyHeader.hide.bind(stickyHeader);
      stickyHeader.hide = function() {
        if (searchIsOpen) {
          console.log('hide() blocked - search is open');
          return;
        }
        originalHide();
      };
    }
    
    if (stickyHeader && stickyHeader.onScroll) {
      const originalOnScroll = stickyHeader.onScroll.bind(stickyHeader);
      stickyHeader.onScroll = function() {
        if (searchIsOpen) {
          return;
        }
        originalOnScroll();
      };
    }
    
    // === 2. 検索ボタンクリック時の処理 ===
    
    searchSummary.addEventListener('click', function(e) {
      const willBeOpen = !searchDetails.hasAttribute('open');
      
      if (willBeOpen) {
        console.log('Search button clicked - will open fullwidth');
        
        setTimeout(function() {
          const header = document.querySelector('.section-header');
          if (header) {
            header.classList.remove('shopify-section-header-hidden');
            header.classList.add('shopify-section-header-sticky');
          }
          applyFullwidthFix();
        }, 10);
      }
    });
    
    // === 3. 検索モーダルを画面幅100%で表示 ===
    
    function applyFullwidthFix() {
      const header = document.querySelector('.section-header');
      
      if (!header) return;
      
      const headerHeight = header.offsetHeight;
      console.log('Applying fullwidth fix, header height:', headerHeight);
      
      if (searchModal) {
        // 画面幅100%で表示
        searchModal.style.position = 'absolute';
        searchModal.style.top = '0';
        searchModal.style.left = '0';
        searchModal.style.right = '0';
        searchModal.style.bottom = 'auto';
        searchModal.style.width = '100%';
        searchModal.style.display = 'block';
        searchModal.style.opacity = '1';
        searchModal.style.visibility = 'visible';
        searchModal.style.minHeight = headerHeight + 'px';
        searchModal.style.height = headerHeight + 'px';
        searchModal.style.zIndex = '100';
      }
      
      if (searchContent) {
        searchContent.style.position = 'relative';
        searchContent.style.top = '0';
        searchContent.style.bottom = 'auto';
        searchContent.style.width = '100%';
        searchContent.style.maxWidth = '100%';
        searchContent.style.display = 'flex';
        searchContent.style.alignItems = 'center';
        searchContent.style.justifyContent = 'center';
        searchContent.style.minHeight = headerHeight + 'px';
        searchContent.style.height = headerHeight + 'px';
        searchContent.style.margin = '0';
        
        // レスポンシブpadding
        if (window.innerWidth >= 990) {
          searchContent.style.padding = '0 8rem 0 4rem';
        } else if (window.innerWidth >= 750) {
          searchContent.style.padding = '0 4rem 0 2rem';
        } else {
          searchContent.style.padding = '0 3rem 0 1.5rem';
        }
      }
      
      // 検索フォームを100%に
      const searchForm = searchModal ? searchModal.querySelector('.search-modal__form') : null;
      if (searchForm) {
        searchForm.style.width = '100%';
        searchForm.style.maxWidth = 'none';
      }
      
      // modal-overlayの位置と表示
      const modalOverlay = searchModal ? searchModal.querySelector('.modal-overlay') : null;
      if (modalOverlay) {
        modalOverlay.style.display = 'block';
        modalOverlay.style.position = 'fixed';
        modalOverlay.style.top = headerHeight + 'px';
        modalOverlay.style.left = '0';
        modalOverlay.style.right = '0';
        modalOverlay.style.bottom = '0';
        modalOverlay.style.width = '100%';
        modalOverlay.style.height = 'calc(100vh - ' + headerHeight + 'px)';
        modalOverlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
        modalOverlay.style.zIndex = '50';
        modalOverlay.style.pointerEvents = 'auto';
        console.log('Modal overlay displayed');
      }
      
      console.log('Fullwidth fix applied');
    }
    
    // リサイズ時にも再適用
    let resizeTimer;
    window.addEventListener('resize', function() {
      if (searchIsOpen) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(applyFullwidthFix, 100);
      }
    });
  }
  
  // 初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();